var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"program-soc-form"},[_c('ValidationObserver',{ref:"firstForm",scopedSlots:_vm._u([{key:"default",fn:function({ handleSubmit }){return [_c('form',{attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.onSubmit)}}},[_c('v-row',{staticClass:"px-5 py-5",attrs:{"lg":"12"}},[_c('v-col',{staticClass:"form-separator",attrs:{"md":"12"}},[_c('h4',[_vm._v("Data Identifier")])]),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Code',
            validation: ['required'],
            type: 'text',
          }},model:{value:(_vm.formData.code),callback:function ($$v) {_vm.$set(_vm.formData, "code", $$v)},expression:"formData.code"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Nama',
            validation: ['required'],
            type: 'text',
          }},model:{value:(_vm.formData.name),callback:function ($$v) {_vm.$set(_vm.formData, "name", $$v)},expression:"formData.name"}})],1),_c('v-col',{staticClass:"form-separator",attrs:{"md":"12"}},[_c('h4',[_vm._v("Lokasi Persemaian")])]),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Persemaian',
            validation: ['required'],
            col_size: 6,
            type: 'select',
            setter: 'id',
            option: {
              getterKey: 'data',
              default_options: _vm.$store.state.nurseries,
              list_pointer: {
                code: 'id',
                label: 'name',
                display: ['name'],
              },
            },
          }},model:{value:(_vm.formData.nursery_locations_id),callback:function ($$v) {_vm.$set(_vm.formData, "nursery_locations_id", $$v)},expression:"formData.nursery_locations_id"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Management Unit',
            validation: ['required'],
            col_size: 6,
            type: 'select',
            setter: 'mu_no',
            api: 'new-utilities/management-units',
            option: {
              getterKey: 'data',
              list_pointer: {
                code: 'mu_no',
                label: 'name',
                display: ['name'],
              },
            },
          }},model:{value:(_vm.formData.mu_no),callback:function ($$v) {_vm.$set(_vm.formData, "mu_no", $$v)},expression:"formData.mu_no"}})],1),_c('v-col',{staticClass:"form-separator",attrs:{"md":"12"}},[_c('h4',[_vm._v("Tanggal Distribusi")])]),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Periode distribusi',
            validation: ['required'],
            type: 'daterange',
            setter: 'date',
          }},model:{value:(_vm.formData.form_date),callback:function ($$v) {_vm.$set(_vm.formData, "form_date", $$v)},expression:"formData.form_date"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Tahun Program',
            validation: ['required'],
            type: 'select',
            setter: 'program_year',
            option: {
              default_options: _vm.$_config.programYear.options.map(
                (x) => {
                  return {
                    code: x,
                    label: x,
                  };
                }
              ),
              list_pointer: {
                code: 'code',
                label: 'label',
                display: ['label'],
              },
            },
          }},model:{value:(_vm.formData.program_year),callback:function ($$v) {_vm.$set(_vm.formData, "program_year", $$v)},expression:"formData.program_year"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Jumlah Hari Libur',
            validation: ['required'],
            type: 'number',
          }},model:{value:(_vm.formData.nursery_days_off_amount),callback:function ($$v) {_vm.$set(_vm.formData, "nursery_days_off_amount", $$v)},expression:"formData.nursery_days_off_amount"}})],1),(Number(_vm.formData.nursery_days_off_amount) > 0)?_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"disabled":Number(_vm.formData.nursery_days_off_amount) <= 0,"item":{
              label: 'Interval Hari Libur',
              validation: ['required'],
              type: 'number',
            }},model:{value:(_vm.formData.nursery_days_off_interval),callback:function ($$v) {_vm.$set(_vm.formData, "nursery_days_off_interval", $$v)},expression:"formData.nursery_days_off_interval"}})],1):_vm._e(),_c('v-col',{staticClass:"form-separator",attrs:{"md":"12"}},[_c('h4',[_vm._v("Limitasi Bibit")])]),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
            label: 'Limitasi Bibit',
            validation: ['required'],
            type: 'number',
          }},model:{value:(_vm.formData.seed_limitation),callback:function ($$v) {_vm.$set(_vm.formData, "seed_limitation", $$v)},expression:"formData.seed_limitation"}})],1),_c('v-col',{attrs:{"lg":"12"}},[_c('div',{staticClass:"d-flex flex-row",staticStyle:{"justify-content":"flex-end"}},[_c('v-btn',{attrs:{"variant":"success","type":"submit","disabled":_vm.loading}},[_c('v-icon',[_vm._v("mdi-plus")]),(_vm.isCreate)?_c('span',[_vm._v("Tambah Data")]):_c('span',[_vm._v("Perbaharui Data")])],1)],1)])],1)],1)]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }